import api from "@/lib/api";

const KEY = "autheuil_palettes_queue";
const EVT = "autheuil:queue";

export const isNetworkError = (err) => !err?.response;

export function getQueue() {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch (_) { return []; }
}

function save(q) {
  localStorage.setItem(KEY, JSON.stringify(q));
  window.dispatchEvent(new Event(EVT));
}

export function enqueuePalette(payload) {
  const item = { local_id: `LOC-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`, payload,
    created_at: new Date().toISOString(), error: null };
  save([...getQueue(), item]);
  return item;
}

export function removeFromQueue(localId) {
  save(getQueue().filter((i) => i.local_id !== localId));
}

let syncing = false;
export async function syncQueue() {
  if (syncing || !navigator.onLine) return { done: 0, failed: 0 };
  syncing = true;
  let done = 0, failed = 0;
  try {
    for (const item of getQueue()) {
      try {
        await api.post("/palettes", item.payload);
        removeFromQueue(item.local_id);
        done += 1;
      } catch (err) {
        failed += 1;
        if (isNetworkError(err)) break;
        const q = getQueue();
        const it = q.find((i) => i.local_id === item.local_id);
        if (it) { it.error = err.response?.data?.detail || "Refusée par le serveur"; save(q); }
      }
    }
  } finally {
    syncing = false;
    window.dispatchEvent(new Event(EVT));
  }
  return { done, failed };
}

export function onQueueChange(cb) {
  window.addEventListener(EVT, cb);
  return () => window.removeEventListener(EVT, cb);
}

let started = false;
export function startAutoSync(onSynced) {
  if (started) return;
  started = true;
  const run = async () => {
    const r = await syncQueue();
    if (r.done && onSynced) onSynced(r);
  };
  window.addEventListener("online", run);
  setInterval(run, 30000);
  run();
}
